// src/components/AdminSidebar.js
import { useState } from 'react';
import CommonSidebar from './CommonSidebar';

function AdminSidebar({ isOpen, onToggle }) {
  const menuItems = [
    { path: '/admin', icon: '📊', label: 'Dashboard', exact: true },
    { path: '/admin/students', icon: '👥', label: 'Students' },
    { path: '/admin/teachers', icon: '👨‍🏫', label: 'Teachers' },
    { path: '/admin/courses', icon: '📚', label: 'Courses' },
    { path: '/admin/student-requests', icon: '📥', label: 'Registration Requests' },
    { path: '/admin/settings', icon: '⚙️', label: 'Settings' }
  ];

  return (
    <CommonSidebar
      isOpen={isOpen}
      onToggle={onToggle}
      userType="admin"
      menuItems={menuItems}
      logoText={{ primary: "ADMIN", secondary: "PANEL" }}
    />
  );
}

export default AdminSidebar;